import { WidgetType } from "@codemirror/view";

export class EndWidget extends WidgetType {
    toDOM() {
        const element = document.createElement("div");
        element.classList.add("ol-cm-end");
        return element;
    }

    eq() {
        return true;
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}
